import { render, staticRenderFns } from "./Vitalsign.vue?vue&type=template&id=7d352877&"
import script from "./Vitalsign.vue?vue&type=script&lang=ts&"
export * from "./Vitalsign.vue?vue&type=script&lang=ts&"
import style0 from "./Vitalsign.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports